<template>
  <CommonModal>
    <template slot="header">
      <h3>Add Document Type</h3>
    </template>
    <template slot="body">
      <div style="overflow: auto; height: 450px">
        <table class="write_tbl">
          <tbody>
            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="form.modelcodeVO.modelcodeName"
                  v-validate="'required'"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="form.modelcodeVO.modelcodeDesc"
                ></textarea>
              </td>
            </tr>
            <tr>
              <th>사용여부</th>
              <td>
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.modelcodeVO.useYn"
                    value="Y"
                  />
                  Use</label
                >
                <label
                  ><input
                    type="radio"
                    name="useYn"
                    v-model="form.modelcodeVO.useYn"
                    value="N"
                  />
                  Unused</label
                >
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <table class="write_tbl" v-for="(item, index) in form.languages" :key="index">
          <tbody>
            <tr>
              <th>언어</th>
              <td>
                {{ item.language.codeName }}
              </td>
            </tr>

            <tr>
              <th>이름</th>
              <td>
                <input
                  type="text"
                  name="doctypeName"
                  class="form-control"
                  v-model="item.name"
                />
              </td>
            </tr>
            <tr>
              <th>설명</th>
              <td colspan="2">
                <textarea
                  class="form-control"
                  name="doctypeDesc"
                  v-model="item.desc"
                ></textarea>
              </td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </template>
    <template slot="footer">
      <slot name="footer"> </slot>
    </template>
  </CommonModal>
</template>

<script>
import CommonModal from "@/components/modal/CommonModal";
import { getModelCodeAndLabel, update, checkModelNameDuplication } from "@/api/modelcode";

export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      form: {
        modelcodeVO: {
          doctypeId: "",
          doctypeName: "",
          doctypeDesc: "",
          useYn: "Y",
        },

        languages: [],
      },
      modelCode: "",
    };
  },
  methods: {
    // async save(){
    //   try {
    //     const response = await addDocType(this.form);
    //     console.log(response);
    //     if(response.data.success){
    //       this.reset();
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    async fetchData(doctypeId) {
      try {
        const response = await getModelCodeAndLabel(doctypeId);
        console.log(response);
        this.form = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      const validForm = await this.$validator.validateAll();
      if (validForm) {
        //modelCodeName 중복확인
        const { data } = await checkModelNameDuplication(this.form);
        this.modelCode = data.modelCode;
        if (
          this.modelCode == null ||
          this.modelCode == "" ||
          this.modelCode.length == 0
        ) {
          try {
            const response = await update(this.form);
            return response.data.status;
          } catch (error) {
            console.log(error);
          }
        } else {
          return "alert.alreadyExist";
        }
      } else {
        return "alert.plzCheckAllValues";
      }
    },
    // reset() {
    //   this.form.doctypeId='';
    //   this.form.doctypeName='';
    //   this.form.doctypeDesc='';
    //   this.form.useYn='Y'
    // },
    // async fetchDoctypeForm() {
    //   const response = await fetchDoctypeForm();
    //   console.log(response);
    //   this.form.languages = response.data.forms;
    // }
  },
};
</script>

<style></style>
